<template>
  <div class="mit-admin-page mit-page">
    <BaseMitLoading :show="loadingReservationsList || loadingSave || loadingDelete" :fullscreen="false"/>
    <BaseMitReserveEdit :show="dialog" :existingReservationUniqueId="currentReservationUniqueId" @cancel="cancelReservation" @save="saveReservation" @delete="deleteReservation"/>
    <v-container fluid>
        <span v-if="reservations && reservations.length > 0">
            <v-simple-table class="row-pointer" fixed-header height="300px">
              <template v-slot:default >

                <!-- <span v-if="reservations && reservations.length > 0"> -->
                    <thead>
                      <tr>
                          <th class="text-left">Name</th>
                          <th class="text-left">Space</th>
                          <th class="text-left">Date</th>
                          <th class="text-left">Time</th>
                          <th class="text-left">Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- @click="editReservation(r)" -->
                      <tr v-for="r in reservations" :key="r.id" @click="editReservation(r)">
                        <td><h4>{{r.name || '(none)'}}</h4></td>
                        <td>{{ r.mitId }}</td>
                        <td>{{ r.startDateDisplay1 }}</td>
                        <td>{{ r.startTime }}</td>
                        <!-- <td>{{ r.endDateTime.format('MMM DD YYYY h:mm A') }}</td> -->
                        <td>{{ r.durationDisplay1 }}</td>
                      </tr>
                  </tbody>
              </template>
            </v-simple-table>
        </span>
        <span v-else>No Reservations scheduled</span>
        
    </v-container>
  </div>
</template>

<script>  
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitReservationService from '../../base/services/BaseMitReserveService.js';
  import BaseMitReserveEdit from '../../base/components/reserve/BaseMitReserveEdit.vue';

  export default {
    name: 'MitMyReservationsSimple',
    components: {
      BaseMitReserveEdit,
      BaseMitLoading
    },
    props: {
        userModel: Object
    },
    data: function() {
      return {
          dialog:false,
          loadingReservationsList:true,
          loadingDelete:false,
          loadingSave:false,
          currentReservationUniqueId:null,
          reservations:[]
      }
    },
    created() {
        this.getReservations();
    },
    mounted() {

    },
    methods: {
        getReservations(){
          this.loadingReservationsList = true;
          //MitReservationService.getMyReservations(this.userModel.userId)
          MitReservationService.getMyReservationsRecurringGrouped(this.userModel.csailId)
                  .then((data) => {
                      this.reservations = data.all
                      this.loadingReservationsList = false;
                  })
                  .catch((error) => {
                      console.log('ERROR:', error);
                      this.loadingReservationsList = false;
                  });
        },
        editReservation(reservation){
          this.currentReservationUniqueId = reservation.uniqueId;
          this.dialog = true;

        },
        deleteReservation(reservation){
            this.loadingDelete = true;
            this.dialog = false;
            MitReservationService.delete(reservation.uniqueId)
              .then((data) => {
                  this.loadingDelete = false;

                  // if(data.numDeleted <= 0){
                  //     this.status.message = 'Could not delete reservation or reservation was already deleted.';
                  //     this.status.color = 'red';
                  //     this.status.display = true;
                  // }
                  // else{
                  //     this.status.message = 'Deleted Reservation.',
                  //     this.status.color = 'primary'
                  //     this.status.display = true;
                  // }
                  this.getReservations();
                  this.$emit('changed');
              })
              .catch((error) => {
                  // this.loadingDelete = false;
                  // this.status.message = 'An error occurred trying to get the reservable spaces.';
                  // this.status.display = true;
                  // this.status.color = 'red';
                  // this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });

        },
        cancelReservation(){
          this.dialog = false;
        },
        saveReservation(reservation){
            this.loadingSave = true;

            MitReservationService.save(reservation)
              .then((data) => {
                  this.loadingSave = false;
                  // this.status.message = 'Saved!',
                  // this.status.color = 'primary'
                  // this.status.display = true;
                  this.dialog = false;
                  this.getReservations();
                  this.$emit('changed');
              })
              .catch((error) => {
                  this.loadingSave = false;
                  this.dialog = false;
                  this.getReservations();
                  // this.status.message = 'An error occurred trying to get the reservable spaces.';
                  // this.status.display = true;
                  // this.status.color = 'red';
                  // this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });
        }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .row-pointer {
    tbody {
      tr {
        cursor: pointer;
      }
    }
  }

</style>
